import { t } from "i18next";
import { getMany, softDeleteById } from "services/role";
import { Util } from "common/util";
import withDataTable from "../withDataTable";

const columns = [
  {
    title: t("text_name"),
    dataIndex: "name",
    key: "name",
  },
];
const pathName = "/setting/role";
const util = new Util();

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (searchStr) {
    option["search"] = searchStr;
  }
  return getMany(option);
};

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  util.pushParamsToURL(pathName, queryParams.toString());
};

export default withDataTable({
  title: t("text_roles"),
  addNewLink: "/setting/role/create",
  updateLink: "/setting/role/update",
  showFilter: false,
  showPagination: true,
  permission: "role",
  pathName,
  columns,
  defaultCurrent,
  defaultPageSize,
  getData,
  handleSearch,
  confirmSoftDelete: (id) => softDeleteById(id),
});
